window.addEventListener('DOMContentLoaded', function () {
    window.rm.search = {
        searchFieldsList: $('.js-search-input'),
        searchClearButtonsList: $('.js-search-clear'),
        searchEl: null,
        searchFieldEl: null,
        searchClearButtonEl: null,
        searchConfirmButtonEl: $('.js-search-confirm-button'),
        searchResultsEl: null,

        init: function () {
            const _this = this

            this.searchFieldsList.on('focus', function (e) {
                const target = $(e.target)
                const search = target.closest('.js-search')
                _this.searchEl = search
                _this.searchFieldEl = search.find('.js-search-input')
                _this.searchClearButtonEl = search.find('.js-search-clear')
                _this.searchResultsEl = search.find('.js-search-results')

                if (_this.searchFieldEl.val()) {
                    _this.fetchSearchResults()
                    _this.searchClearButtonEl.removeClass('hidden')
                }
            })

            this.searchFieldsList.on('input', function (e) {
                const target = $(e.target)
                _this.searchClearButtonEl.toggleClass('hidden', !target.val())
                _this.getShowResultsDebounced()
            })

            this.searchFieldsList.on('blur', this.hideSearchResults.bind(_this))
            this.searchClearButtonsList.on('mousedown', this.clearSearch.bind(_this))
            $('body').on('mousedown', '.js-search-result', this.confirmSearch.bind(_this))
            this.searchConfirmButtonEl.on('mousedown', function () {
                _this.fetchSearchResults.bind(_this)
                _this.hideSearchResults.bind(_this)
            })
        },

        confirmSearch: function (e) {
            this.searchFieldEl.val(e.target.textContent)
            this.searchFieldEl.trigger('change')
        },

        clearSearch: function () {
            this.searchFieldEl.val('')
            this.searchFieldEl.trigger('change')
            this.searchClearButtonEl.addClass('hidden')
        },

        getShowResultsDebounced: debounce(function () {
            window.rm.search.fetchSearchResults()
        }, 300),

        fetchSearchResults: function () {
            var self = this;
            if (!this.searchFieldEl) return
            const searchValue = this.searchFieldEl.val()
            window.rm.location.fetchAddressList(searchValue, function (response) {
                const addressList = response.hints.slice(0, 5);
                const results = self.highlightSearchResults(searchValue, addressList)
                self.createSearchResult(results)
            })
        },

        createSearchResult: function (results) {
            const _this = this
            this.searchResultsEl.empty()

            results.forEach(function (result) {
                const searchResult = $('<div class="search__result js-search-result"></div>')
                searchResult.html(result)
                _this.searchResultsEl.append(searchResult)
            })

            this.showSearchResults()
        },

        showSearchResults: function () {
            this.searchEl.addClass('active')
            this.searchResultsEl.removeClass('hidden')
        },

        hideSearchResults: function () {
            this.searchEl.removeClass('active')
            this.searchResultsEl.addClass('hidden')
        },

        highlightSearchResults: function (searchValue, addressList) {
            addressList = addressList.map(function(address) {
                searchValue = searchValue.replace(/\s+/gi, ' ').trim()
                const regEx = new RegExp(searchValue, "ig");

                return address.replaceAll(regEx, function (substring) {
                    return '<span class="marked">' + substring + '</span>'
                })
            })

            return addressList
        }
    }


    window.rm.search.init()
})
